var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAdmissionImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 400,
    height: 400,
    viewBox: "0 0 400 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_21361",
    "data-name": "Group 21361",
    transform: "translate(15934 14009)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11454",
    "data-name": "Rectangle 11454",
    width: 400,
    height: 400,
    transform: "translate(-15934 -14009)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_21360",
    "data-name": "Group 21360",
    transform: "translate(-14789 -14551)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M173.747,504.162h212.3C433.363,471.512,464.3,417.654,464.3,356.7c0-99.622-82.561-194.7-184.4-194.7S95.5,257.074,95.5,356.7C95.493,417.662,126.429,471.512,173.747,504.162Z",
    transform: "translate(-1224.552 405)",
    fill: "#82bbf1",
    opacity: 0.42
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M469.68,658.02c0-4.238-87.006-7.669-194.34-7.669S81,653.783,81,658.02s87.006,7.669,194.34,7.669S469.68,662.259,469.68,658.02Z",
    transform: "translate(-1220 251.688)",
    fill: "#d3e3eb",
    opacity: 0.43
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M267.793,527.037h-8.841v84.642h8.841Z",
    transform: "translate(-1275.866 290.401)",
    fill: "#b0c4cb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M267.793,527.037h-8.841v11.9h8.841Z",
    transform: "translate(-1275.866 290.401)",
    fill: "#91adb7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M287.194,650.458H209.022a3.1,3.1,0,0,0-3.1,3.105v4.662H290.3v-4.662A3.1,3.1,0,0,0,287.194,650.458Z",
    transform: "translate(-1259.217 251.654)",
    fill: "#b0c4cb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M225.794,470.839h61.271c-22.291-8.012-13.669-83.526-9.55-112.141a9.566,9.566,0,0,0-9.468-10.93H227.235a16.722,16.722,0,0,0-16.568,14.442c-3.582,26.008-9.224,79.931,1.954,100.813A14.912,14.912,0,0,0,225.794,470.839Z",
    transform: "translate(-1259.251 346.68)",
    fill: "#b0c4cb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M505.176,278.994h-73.3a6.807,6.807,0,0,0-6.806,6.814v33.058a6.807,6.807,0,0,0,6.806,6.814H437v8a1.283,1.283,0,0,0,2.141.954l9.908-8.949h56.125a6.807,6.807,0,0,0,6.806-6.814V285.808A6.807,6.807,0,0,0,505.176,278.994Z",
    transform: "translate(-1328.018 368.271)",
    fill: "#82bbf1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M464.067,312.37a3,3,0,1,1-3-3A3,3,0,0,1,464.067,312.37Z",
    transform: "translate(-1338.379 358.734)",
    fill: "#476488"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M490.933,312.37a3,3,0,1,1-3-3A3,3,0,0,1,490.933,312.37Z",
    transform: "translate(-1346.813 358.734)",
    fill: "#476488"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M513.012,315.37a3,3,0,1,0-3-3A3,3,0,0,0,513.012,315.37Z",
    transform: "translate(-1354.685 358.734)",
    fill: "#476488"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M180.357,401.036c0-8.093-5.707-16.2-12.749-16.2s-12.75,8.11-12.75,16.2,5.707,14.646,12.75,14.646S180.357,409.129,180.357,401.036Z",
    transform: "translate(-1243.187 335.044)",
    fill: "#83b6ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M171.944,384.845a9.336,9.336,0,0,0-3.273.62c5.455,2.013,9.477,8.794,9.477,15.583s-4.022,12.479-9.477,14.141a11.2,11.2,0,0,0,3.273.506c7.042,0,12.75-6.561,12.75-14.647S178.986,384.845,171.944,384.845Z",
    transform: "translate(-1247.523 335.04)",
    fill: "#476488",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M152.266,421.444l2.288,20.71a5.105,5.105,0,0,0,5.072,4.548h13.189a5.1,5.1,0,0,0,5.072-4.548l2.287-20.71a1.9,1.9,0,0,0-1.889-2.111H154.163A1.905,1.905,0,0,0,152.266,421.444Z",
    transform: "translate(-1242.37 324.213)",
    fill: "#d3e3eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M154.155,422.418h24.123a1.862,1.862,0,0,1,1.661,1.06l.228-2.046a1.9,1.9,0,0,0-1.889-2.111H154.155a1.9,1.9,0,0,0-1.889,2.111l.228,2.046A1.862,1.862,0,0,1,154.155,422.418Z",
    transform: "translate(-1242.37 324.217)",
    fill: "#b0c4cb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M183.855,419.333h-8.361a1.9,1.9,0,0,1,1.889,2.111l-2.288,20.71a5.1,5.1,0,0,1-5.072,4.548h8.362a5.1,5.1,0,0,0,5.071-4.548l2.288-20.71A1.9,1.9,0,0,0,183.855,419.333Z",
    transform: "translate(-1247.948 324.213)",
    fill: "#b0c4cb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M343.767,631.516,342.9,637.5l4.551,5.828,11.536-5.648,1.254-5.478-14.361-2.176Z",
    transform: "translate(-1302.219 258.069)",
    fill: "#e3bd78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M352.354,654.2l1.189-1.475a.554.554,0,0,1,.855-.008l1.2,1.4a2.5,2.5,0,0,0,1.937.88l26.8-.456a1.447,1.447,0,0,0,.049-2.029c-3.932-3.97-25.076-10.832-26.125-11.411s-7.523,4.45-16.087-.172A89.982,89.982,0,0,0,340.581,652a3.063,3.063,0,0,0,3.093,3.236l6.806-.115A2.484,2.484,0,0,0,352.354,654.2Z",
    transform: "translate(-1301.492 254.645)",
    fill: "#2c3c4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M271.068,483.141s-11.129,12.315,9.249,25.706c14.3,9.389,25.563,6.52,34.543,12.217a7.559,7.559,0,0,1,3.851,5.812l.456,57.583,1.083.538a19.744,19.744,0,0,0,17.186.187l8.117-65.7c.294-4.531-2.157-8.346-4.957-11.916-15.583-19.846-43.181-26.57-50.167-27.72C281.359,478.357,271.068,483.141,271.068,483.141Z",
    transform: "translate(-1278.718 305.306)",
    fill: "#2c3c4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M279.129,631.519l-.952,5.974,4.47,5.893,11.617-5.5,1.319-5.453-14.329-2.372Z",
    transform: "translate(-1281.902 258.058)",
    fill: "#e3bd78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M287.378,654.31l1.213-1.459a.554.554,0,0,1,.855,0l1.181,1.418a2.506,2.506,0,0,0,1.929.9l26.809-.089a1.439,1.439,0,0,0,.073-2.029c-3.876-4.026-24.92-11.175-25.971-11.769s-7.58,4.352-16.079-.391a91.065,91.065,0,0,0-1.742,11.044,3.06,3.06,0,0,0,3.053,3.277l6.806-.025A2.4,2.4,0,0,0,287.378,654.31Z",
    transform: "translate(-1281.105 254.656)",
    fill: "#2c3c4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M221.073,468.146s-13.482,15.045,6.016,32.047c13.677,11.924,25.954,6.822,34.568,14.1a8.027,8.027,0,0,1,3.216,6.659l-6.155,58.577.464.3a18.523,18.523,0,0,0,17.984,1.231l15.248-61.723c.953-4.719-1.066-9.079-3.5-13.236-13.531-23.1-34.78-36.865-41.952-39.073C237.624,464.152,221.073,468.146,221.073,468.146Z",
    transform: "translate(-1262.549 309.567)",
    fill: "#2c3c4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M317.979,519.568a26.949,26.949,0,0,0-3.142-1.092,26.855,26.855,0,0,0-3.428-7.971,105.609,105.609,0,0,0-23.17-27.19c4.885-.831,7.376-1.874,8.727-3.252a92.253,92.253,0,0,1,14.638,3.978C318.24,495.133,318.223,513.146,317.979,519.568Z",
    transform: "translate(-1285.06 305.148)",
    fill: "#1f2e40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M257.194,352.977s-19.45-2.6-27.534,12.576-20.158,74.65-9.6,76.459c4.673.8,17.137,3.937,30.945,2.926,18.985-1.393,23.113-3.138,24.481-6.756l12.09-55.423a23.453,23.453,0,0,0-9.183-19.569A65.91,65.91,0,0,0,257.194,352.977Z",
    transform: "translate(-1262.36 345.098)",
    fill: "#d3e3eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M315.345,389.359s.252,33.384,10.739,35.406,38.394,1.394,38.394,1.394v10.62H304.615Z",
    transform: "translate(-1290.202 333.623)",
    fill: "#b0c4cb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M291.86,356.557l2.361-11.81-15.3-11.663L275.993,347S280.821,368.253,291.86,356.557Z",
    transform: "translate(-1281.216 351.29)",
    fill: "#d4904f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M308.621,306.179s-8,3.9-19.726-3.252c0,0-2.719,4.9-10.576,9.267,0,0-4.079-6.854-6.431-1.72a10.9,10.9,0,0,0-1.083,4.19c-7.359-9.512-2.173-22.047,4.69-28.812,6.5-6.415,20.573-3.863,29.365-.326,9.33,3.757,11.048-2.78,11.048-2.78C327.7,299.382,308.621,306.179,308.621,306.179Z",
    transform: "translate(-1278.462 367.355)",
    fill: "#2c3c4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M279.957,321.8s-4.087-6.854-6.432-1.72c-2.849,6.227.366,10.131,4.225,10.131,0,0,3.061,16.2,17.935,15.054s17.007-25.047,14.581-29.48c0,0-8,3.9-19.726-3.253C290.532,312.531,287.813,317.438,279.957,321.8Z",
    transform: "translate(-1280.099 357.742)",
    fill: "#e3bd78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M436.148,381.269H374.1a6.443,6.443,0,0,0-6.31,5.151l-8.264,40.54h75.193L442.449,389A6.43,6.43,0,0,0,436.148,381.269Z",
    transform: "translate(-1307.439 336.163)",
    fill: "#d3e3eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M421.662,447.88H316.69a1.856,1.856,0,0,0-1.857,1.859v3.415a1.856,1.856,0,0,0,1.857,1.858H421.662a1.856,1.856,0,0,0,1.857-1.858v-3.415A1.856,1.856,0,0,0,421.662,447.88Z",
    transform: "translate(-1293.409 315.251)",
    fill: "#8ba6af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M434.107,447.868H358.336a3.06,3.06,0,0,1,3.061,3.065v.995a3.06,3.06,0,0,1-3.061,3.065h75.779a3.06,3.06,0,0,0,3.061-3.065v-.995A3.077,3.077,0,0,0,434.107,447.868Z",
    transform: "translate(-1307.067 315.255)",
    fill: "#b0c4cb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M290.045,418.814c-12.082-1.41-45.974-4.874-51.787-5.469-7.327-.758,8.589-30.344,10.356-40.458s-5.935-10.5-5.935-10.5c-4.348-.546-9.094,0-13.132,6.129-8.272,12.543-17.488,49.2-12.627,58.259a3.276,3.276,0,0,0,2.89,1.712h70.235Z",
    transform: "translate(-1262.247 342.141)",
    fill: "#d3e3eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M298.386,418.814s-43.638-3.007-53.049-4.271c-7.3-.978,7.914-31.3,9.68-41.412s-6.065-9.691-6.065-9.691a18.588,18.588,0,0,0-6.814.644,12.633,12.633,0,0,1,8.882-1.7s7.7.384,5.935,10.5-15.412,39.073-10.8,40.206C251.826,414.487,286.3,417.4,298.386,418.814Z",
    transform: "translate(-1270.588 342.141)",
    fill: "#b0c4cb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M324.124,455.033H340.4a1.544,1.544,0,0,0,1.295-2.38c-1.522-2.348-3.932-5.657-5.7-6.219-1.05-.334-8.964-.04-11.87.269Z",
    transform: "translate(-1296.326 315.751)",
    fill: "#e3bd78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M317.775,317.283a12.966,12.966,0,0,1-3.688.921c-.2,1.1-.554,3.219-.741,5.233-.269,2.869,1.156,11.736.276,11.81a27.047,27.047,0,0,1-2.727-.065s-1.36,12.829-14.182,10.783c-.122-.016-.22-.032-.333-.049a16.1,16.1,0,0,0,6.814.856C318.06,345.614,320.21,321.717,317.775,317.283Z",
    transform: "translate(-1287.616 356.251)",
    fill: "#d4904f",
    opacity: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M587.8,551.316s20.443-10.155,14.882-25.543-9-16.048,1.636-24.721,26-30.458,6.546-32.1-18.48,24.231-34.674,27.833S551.162,568.18,587.8,551.316Z",
    transform: "translate(-1371.058 308.658)",
    fill: "#83b6ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M576.077,552.841c3.924,1.826,9.208,1.646,16.087-1.524,0,0,20.443-10.155,14.882-25.543s-9-16.048,1.636-24.721,26-30.458,6.546-32.1a17.748,17.748,0,0,0-5.186.277c5.479,2.274,10.926,6.8,3.883,15.16-11.723,13.921-18,18.835-16.632,27.85C598.62,521.022,597.863,540.966,576.077,552.841Z",
    transform: "translate(-1375.424 308.657)",
    fill: "#476488",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M532.45,560.662s-17.993-.653-17.007-13.587,1.482-13.44-9.81-17.523c-19.954-7.205-4.16-45.569,12.106-21.452,11.284,16.741,16.192,12.975,23.552,14.287C548.635,523.7,564.665,566.392,532.45,560.662Z",
    transform: "translate(-1350.375 298.815)",
    fill: "#83b6ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M541.893,522.4c-7.359-1.312-12.269,2.453-23.552-14.287-8.508-12.626-16.885-8.126-20.084.057,4.787-1.467,12.057-2.348,12.969,5.452,1.172,10.123,24.823,26.734,24.343,47.4.318.032.619.057.92.081,3.443-9.088,7.986-20.864,11.87-30.906C546.281,525.855,543.8,522.734,541.893,522.4Z",
    transform: "translate(-1350.993 298.811)",
    fill: "#476488",
    opacity: 0.29
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M547.615,544.461S525.292,522.6,532.9,518.918s22.568,8.354,14.231-4.67-18.057-33.295-6.521-30.1,12.367,6.7,10.942-8.46c-1.848-19.61,9.077-29.717,19.384-23.335s-8.833,49.612-1.717,44.95,13-8.6,14.475-2.951-20.37,27.825-12.269,24.068c10.054-4.671,11.528,3.683,8.345,8.843C576.565,532.431,563.311,563.126,547.615,544.461Z",
    transform: "translate(-1361.372 314.445)",
    fill: "#476488"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M589.55,527.283c3.191-5.159,1.718-13.505-8.345-8.843-8.1,3.758,13.734-18.419,12.269-24.068s-7.359-1.72-14.475,2.95,12.025-38.559,1.718-44.949c-4.795-2.967-9.7-2.331-13.417,1.125,5.333,1.3,9.607,5.6,6.643,17.2-6.268,24.574-10.087,45.047,1.36,39.041,10.787-5.657-12.53,20.417-12.766,39.2C575.938,556.6,586.717,531.864,589.55,527.283Z",
    transform: "translate(-1371.173 314.434)",
    fill: "#2c3c4d",
    opacity: 0.48
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M532.528,589.4l4.324,39.163a9.648,9.648,0,0,0,9.59,8.6h24.936a9.655,9.655,0,0,0,9.59-8.6l4.323-39.163a3.6,3.6,0,0,0-3.574-3.994H536.1A3.6,3.6,0,0,0,532.528,589.4Z",
    transform: "translate(-1361.745 272.077)",
    fill: "#d3e3eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M592.267,585.4H576.449a3.6,3.6,0,0,1,3.574,3.994L575.7,628.56a9.648,9.648,0,0,1-9.59,8.6h15.819a9.655,9.655,0,0,0,9.59-8.6l4.323-39.163A3.6,3.6,0,0,0,592.267,585.4Z",
    transform: "translate(-1372.295 272.077)",
    fill: "#b0c4cb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M410.862,458.846H139.2a3.292,3.292,0,0,0-3.289,3.292V468.2a3.292,3.292,0,0,0,3.289,3.292H410.862a3.292,3.292,0,0,0,3.289-3.292v-6.064A3.292,3.292,0,0,0,410.862,458.846Z",
    transform: "translate(-1237.237 311.808)",
    fill: "#5d8ac8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M408.712,458.846H141.345a5.44,5.44,0,0,0-5.438,5.444v1.761a5.237,5.237,0,0,0,.285,1.646,5.413,5.413,0,0,1,5.153-3.79H408.721a5.415,5.415,0,0,1,5.154,3.79,5.5,5.5,0,0,0,.285-1.646V464.29A5.453,5.453,0,0,0,408.712,458.846Z",
    transform: "translate(-1237.237 311.808)",
    fill: "#4772a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M234.473,603.429h-8.939L163.367,477.367h8.939Z",
    transform: "translate(-1245.858 305.994)",
    fill: "#476488"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M123.6,603.429h8.939l62.167-126.062h-8.939Z",
    transform: "translate(-1233.374 305.994)",
    fill: "#476488"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M515.036,603.429H506.1L443.931,477.367h8.93Z",
    transform: "translate(-1333.938 305.994)",
    fill: "#476488"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M404.165,603.429H413.1l62.175-126.062h-8.939Z",
    transform: "translate(-1321.454 305.994)",
    fill: "#476488"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M174.765,482.363l-2.459-5h-8.939l2.467,5Z",
    transform: "translate(-1245.858 305.994)",
    fill: "#293951"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M219.571,482.363l2.459-5h-8.939l-2.459,5Z",
    transform: "translate(-1260.697 305.994)",
    fill: "#293951"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M455.329,482.363l-2.467-5h-8.93l2.458,5Z",
    transform: "translate(-1333.938 305.994)",
    fill: "#293951"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M500.123,482.363l2.467-5H493.65l-2.466,5Z",
    transform: "translate(-1348.773 305.994)",
    fill: "#293951"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdmissionImage);
export default __webpack_public_path__ + "static/media/admission-image.7d4ede67661b8d187bed7166ff1c286d.svg";
export { ForwardRef as ReactComponent };